import React from "react";
import styles from "./index.module.css";
import { createPortal } from "react-dom";
import Close from "./close";

export default class PopupModal extends React.Component {
  render() {
    return createPortal(
      <div className={styles.portal}>
        <div className={styles.background} onClick={this.props.close} />
        <div
          className={[styles.content, this.props.contentClassName]
            .filter(Boolean)
            .join(" ")}
        >
          <div
            className={[styles.close, this.props.closeClassName]
              .filter(Boolean)
              .join(" ")}
            onClick={this.props.close}
          >
            <Close height={this.props.closeIconHeight || "20px"} />
          </div>
          {this.props.children}
        </div>
      </div>,
      document.getElementById("modal"),
    );
  }
}
